import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

const SelectMaterial = ({ id, options, onChange, value, text, image, imageWidth }) => {
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <FormControl fullWidth variant="standard">
            <InputLabel id={`${id}-label`}>{text}</InputLabel>
            <Select
                labelId={`${id}-label`}
                id={id}
                value={value || ''}
                label={text}
                onChange={handleChange}
                variant="standard"
            >
                {options?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {option.image && (
                                <img
                                    src={option.image}
                                    alt={option.label}
                                    style={{
                                        width: imageWidth || 20,
                                        height: imageWidth || 20,
                                        marginRight: 8,
                                    }}
                                />
                            )}
                            {option.label}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectMaterial;
